import {
    GET_ZAKAT_DATA,
    PURGE_FITRAH,
    UPDATE_SOURCE_OF_INCOME,
    UPDATE_TOTAL, UPDATE_ZAKAT_DATA, UPDATE_ZAKAT_FITRAH_DATA, ZAKAT_PURGE
} from "../constants";

export function updateZakatData(zakat){
  return {
      type: UPDATE_ZAKAT_DATA,
      zakat
  }
}

export function getZakatData(){
  return {
      type: GET_ZAKAT_DATA,
  }
}

export function resetZakatData() {
  return {
      type: ZAKAT_PURGE,
  }
}

export function resetFitrahData(zakat){
  return {
      type: PURGE_FITRAH,
      zakat
  }
}

export function updateAmount(total){
  return {
      type: UPDATE_TOTAL,
      total
  }
}

export function updateSourceOfIncome(source) {
  return {
      type: UPDATE_SOURCE_OF_INCOME,
      source
  }
}

export function updateZakatFitrahData(fitrahType, data) {
  return {
    type: UPDATE_ZAKAT_FITRAH_DATA,
    payload: { fitrahType, data },
  };
}
